<template>
    <div>
        <StandardizedContract/>
    </div>
</template>
<script>
import StandardizedContract from '@/components/pages/home/leuco-contract-view/standardized-contract/standardized-contract.vue'
export default {
    components: {
        StandardizedContract
    }
}
</script>